import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";

export default function ReturnsPage() {
  return (
    <div className="min-h-screen pt-32 pb-24 px-6 md:px-12" data-testid="returns-page">
      <SEO title="Returns & Exchanges" description="We want you to love your reminder. Returns accepted within 30 days." />
      <div className="max-w-[900px] mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="mb-16"
        >
          <p className="font-mono text-[#FFD700] text-sm tracking-[0.3em] mb-2">SUPPORT</p>
          <h1 className="font-heading text-5xl md:text-7xl tracking-tight uppercase leading-[0.9]">
            RETURNS & <span className="text-[#FFD700]">EXCHANGES</span>
          </h1>
        </motion.div>

        <div className="space-y-10 text-[#C0C0C0] text-base leading-relaxed">
          <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }}
            className="text-xl md:text-2xl text-white font-medium leading-relaxed">
            We want you to love your reminder.
          </motion.p>

          <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.2 }}>
            If your item doesn't fit or arrives damaged, please contact us within 30 days of receiving your order.
          </motion.p>

          <motion.section initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.3 }}>
            <h2 className="font-heading text-xl text-white mb-4">TO BE ELIGIBLE FOR A RETURN OR EXCHANGE, ITEMS MUST BE:</h2>
            <ul className="space-y-3">
              <li className="flex gap-3">
                <span className="text-[#FFD700] mt-1">&#8226;</span>
                <span>Unworn</span>
              </li>
              <li className="flex gap-3">
                <span className="text-[#FFD700] mt-1">&#8226;</span>
                <span>Unwashed</span>
              </li>
              <li className="flex gap-3">
                <span className="text-[#FFD700] mt-1">&#8226;</span>
                <span>In original condition</span>
              </li>
            </ul>
          </motion.section>

          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.4 }}
            className="border-l-4 border-[#FFD700] pl-6 py-4">
            <p className="font-heading text-lg text-white mb-1">Contact us:</p>
            <a href="mailto:hello@think3t.com.au" className="font-mono text-[#FFD700] hover:underline">hello@think3t.com.au</a>
          </motion.div>

          <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.5 }}
            className="text-[#A3A3A3] text-sm">
            See also: <Link to="/refund-policy" className="text-[#FFD700] hover:underline">Refund Policy</Link> · <Link to="/shipping" className="text-[#FFD700] hover:underline">Shipping</Link> · <Link to="/terms" className="text-[#FFD700] hover:underline">Terms & Conditions</Link>
          </motion.p>
        </div>
      </div>
    </div>
  );
}
